const dynamicEnvs = {
  "eclaims.kwadr.net": {
    api: "https://rcm.kwadr.net/public/tabebekapi/",
    status: "https://rcm.kwadr.net/public",
  },
  "eliteskills.tabebek.net": {
    api: "https://eliteakillspanel.tabebek.net/tabebekapi/",
    status: "https://eliteakillspanel.tabebek.net/ELITESKILLS",
  },
  "bhcfms.tabebek.net": {
    api: "https://bhcfmspanel.tabebek.net/tabebekapi/",
    status: "https://bhcfmspanel.tabebek.net/BHCFMS",
  },
  "mskcare.tabebek.net": {
    api: "https://mskcarepanel.tabebek.net/tabebekapi/",
    status: "https://mskcarepanel.tabebek.net/MSKCARE",
  },
  "darafia.tabebek.net": {
    api: "https://darafiapanel.tabebek.net/tabebekapi/",
    status: "https://darafiapanel.tabebek.net/DARAFIA",
  },
  "bellapt.tabebek.net": {
    api: "https://bellaptpanel.tabebek.net/tabebekapi/",
    status: "https://bellaptpanel.tabebek.net/BELLAPT",
  },
  "fastfocus.tabebek.net": {
    api: "https://fastfocuspanel.tabebek.net/tabebekapi/",
    status: "https://fastfocuspanel.tabebek.net/FASTFOCUS",
  },
  "nsneurospine.tabebek.net": {
    api: "https://nsneurospinepanel.tabebek.net/tabebekapi/",
    status: "https://nsneurospinepanel.tabebek.net/NEUROSPINE",
  },
  "eradah.tabebek.net": {
    api: "https://childwillpanel.tabebek.net/tabebekapi/",
    status: "https://childwillpanel.tabebek.net/CHILDWILL",
  },
  "crc.tabebek.net": {
    api: "https://crcpanel.tabebek.net/tabebekapi/",
    status: "https://crcpanel.tabebek.net/CRC",
  },
  "physioworld.tabebek.net": {
    api: "https://physioworldpanel.tabebek.net/tabebekapi/",
    status: "https://physioworldpanel.tabebek.net/PHYSIOWORLD",
  },
  "risebloom.tabebek.net": {
    api: "https://risebloom.tabebek.net/tabebekapi/",
    status: "https://risebloom.tabebek.net/RISEBLOOM",
  },
};

const currentHost = window.location.hostname;
// const currentHost = "eradah.tabebek.net";

const defaultEnv = {
  api: "https://rcm.kwadr.net/public/tabebekapi/",
  status: "https://rcm.kwadr.net/public",
};

const resolvedEnv = dynamicEnvs[currentHost] || defaultEnv;

export const baseUrl = resolvedEnv?.api;
export const baseUrlInternal = resolvedEnv?.status;
